/**
 * Las rutas del area, en un solo sitio.
 *
 * Estan aqui y no dentro de una pantalla porque las nombran cuatro archivos --el
 * guardia, la puerta, el panel y el router-- y escritas a mano en cuatro sitios
 * acaban desincronizadas. Ya existia esa razon en la version anterior, donde
 * `RUTA_ACCESO` se exportaba desde la propia pantalla de acceso; lo unico que
 * cambia es que ahora tambien hay panel y demo, y un archivo que no es una
 * pantalla no obliga a importar una pantalla para saber una ruta.
 */

export const RUTA_AREA = '/inversionistas';
export const RUTA_ACCESO = '/inversionistas/acceso';
export const RUTA_PANEL = '/inversionistas/panel';
export const RUTA_DEMO = '/inversionistas/demo';
/**
 * Recuperar la contrasena. FUERA del guardia, como la puerta: quien la usa es
 * justo quien no puede entrar, y ponerla dentro la haria inalcanzable para el
 * unico caso para el que existe.
 */
export const RUTA_RECUPERAR = '/inversionistas/recuperar';
/**
 * La pantalla de administracion. Cuelga del area y no de una `/admin` propia:
 * es la misma sesion, el mismo guardia y el mismo hostname, y una ruta de
 * primer nivel habria pedido su propia entrada en el router y su propio
 * guardia para no ganar nada.
 */
export const RUTA_PORTERO = '/inversionistas/acceso-de-inversionistas';
